import ReactDOM from "react-dom/client";
import App from "./pages/App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store, history } from "./store";
import { BrowserRouter } from "react-router-dom";
import setupAxios from "./middlewares/setupAxios";
import "reactjs-popup/dist/index.css";
import "./assets/styles/index.scss";
import { RoktLauncherContextProvider } from "./rokt";

setupAxios(store);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <Provider store={store}>
    <BrowserRouter>
      <RoktLauncherContextProvider accountId="3051817616807297594" sandbox={false}>
      {/* <React.StrictMode> */}
      <App />
      {/* </React.StrictMode> */}
      </RoktLauncherContextProvider>
    </BrowserRouter>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
